"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create_default = exports.bulk_save = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const Env_1 = require("../../utils/tsUtils/Env");
const paymentMethodService_1 = require("./service/paymentMethodService");
exports.fetch = (0, toolkit_1.createAsyncThunk)("paymentMethod/list", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const paymentMethodService = new paymentMethodService_1.PaymentMethodService(Env_1.APIPATHENV);
        const response = yield paymentMethodService.fetch(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch payment methods");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("paymentMethod/create", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const paymentMethodService = new paymentMethodService_1.PaymentMethodService(Env_1.APIPATHENV);
        const response = yield paymentMethodService.create(payload);
        return response;
    }
    catch (err) {
        throw err;
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("paymentMethod/update", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const paymentMethodService = new paymentMethodService_1.PaymentMethodService(Env_1.APIPATHENV);
        const response = yield paymentMethodService.update(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to update payment method");
    }
}));
exports.bulk_save = (0, toolkit_1.createAsyncThunk)("paymentMethod/bulk_save", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const paymentMethodService = new paymentMethodService_1.PaymentMethodService(Env_1.APIPATHENV);
        const response = yield paymentMethodService.bulk_save(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to update payment method");
    }
}));
exports.create_default = (0, toolkit_1.createAsyncThunk)("paymentMethod/create_default", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const paymentMethodService = new paymentMethodService_1.PaymentMethodService(Env_1.APIPATHENV);
        const response = yield paymentMethodService.create_default(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to create default payment method");
    }
}));
